import { CollectionApi } from '@/api';
import { apiConfiguration } from '@/api/config';

export const collectionApi = new CollectionApi(apiConfiguration);

export const getAllCollectionsQueryFn = async (options?: RequestInit) => {
    return collectionApi.collectionControllerGetAllCollections(options);
};
